<cgp-app-card titleText="Tool Progress Reporting" showFullScreenToggle="true" *ngIf="router.url==='/tprecm'">
   <div [ngSwitch]="display">
      <div *ngSwitchCase="'loaded'">
         <div class="home-toolbar">
            <span featurePermission="tableMaintenance">
               <button mat-button [matMenuTriggerFor]="tableMaintMenu" featurePermissionAny>Table
                  Maintenance<i class="fa fa-caret-down menu-caret-down"></i></button>
               <mat-menu #tableMaintMenu="matMenu">
                  <button subFeaturePermission="source" mat-menu-item
                     (click)="onSourcesMenuItemClick()">Sources</button>
                  <button subFeaturePermission="program" mat-menu-item
                     (click)="onProgramMaintenanceClick()">Programs</button>
                  <button subFeaturePermission="tpr" mat-menu-item
                     (click)="onTprInactiveClick('/tprecm/view-update-tpr/inactive')">Inactive TPR's</button>
               </mat-menu>
            </span>
            <span *ngIf="isSuperUser() | async">
               <button mat-button [matMenuTriggerFor]="adminMenu">Administration<i
                     class="fa fa-caret-down menu-caret-down"></i></button>
               <mat-menu #adminMenu="matMenu">
                  <button mat-menu-item (click)="onReasonCodesMenuItemClick()">Reason Codes</button>
                  <button mat-menu-item (click)="onUsersMenuItemClick()">Users</button>
                  <button mat-menu-item (click)="onClassesMenuItemClick()">Classes</button>
                  <button mat-menu-item (click)="onBatchJobsMenuItemClick()">Batch Jobs</button>
                  <button mat-menu-item (click)="onBuildDesignWeightsItemClick()">Build Design Weights</button>
               </mat-menu>
            </span>
            <span featurePermission="report">
               <button mat-button [matMenuTriggerFor]="reportingMenu" featurePermissionAny>Reporting<i
                     class="fa fa-caret-down menu-caret-down"></i></button>
               <mat-menu #reportingMenu="matMenu">
                  <span>
                     <button subFeaturePermission="master" mat-menu-item (click)="onMasterReportClick()"
                        matTooltip="Click this button to create the Master Report in MS Excel.">Master
                        Report</button>
                     <button subFeaturePermission="quoteCompliance" mat-menu-item
                        (click)="onQuoteComplianceReportClick()"
                        matTooltip="Click this button to create the Quote Compliance Report in MS Excel.">Quote
                        Compliance Report</button>
                     <button subFeaturePermission="program" mat-menu-item (click)="onProgramReportClick()"
                        matTooltip="Click this button to create the Program Report in MS Excel.">Program
                        Report</button>
                     <button subFeaturePermission="regional" mat-menu-item (click)="onRegionalReportClick()"
                        matTooltip="Click this button to create the Regional Report in MS Excel.">Regional
                        Report</button>
                     <button subFeaturePermission="egm" mat-menu-item (click)="onEgmReportClick()"
                        matTooltip="Click this button to create the EGM Report in MS Excel.">EGM
                        Report</button>
                     <button subFeaturePermission="metric" mat-menu-item (click)="onMetricsReportClick()"
                        matTooltip="Click this button to create the Metrics Report in MS Excel.">Metrics
                        Report</button>
                     <span mat-menu-item class="span-menu-item">
                        <button subFeaturePermission="missingPrgInfoChart" (click)="onMissingProgramInfoChartClick()"
                           matTooltip="Click this button to create the Missing Program Chart in MS Excel.">
                           Missing Program Information Chart
                        </button>
                     </span>
                     <button subFeaturePermission="design" mat-menu-item (click)="onDesignReportClick()"
                        matTooltip="Click this button to create the Design Report in MS Excel.">Design
                        Report</button>
                  </span>
                  <div featurePermission="fileUpload">
                     <hr class="menu-item-separator" />
                     <button subFeaturePermission="summary" mat-menu-item (click)="onFileUploadSummaryClick()">File
                        Upload Summary</button>
                  </div>
               </mat-menu>
            </span>
            <span featurePermission="report">
               <button mat-button [matMenuTriggerFor]="tmacsMenu" featurePermissionAny>TMaCS<i
                     class="fa fa-caret-down menu-caret-down"></i></button>
               <mat-menu #tmacsMenu="matMenu">
                  <button mat-menu-item (click)="onFixtureBuildClick()" subFeaturePermission="tmacs"
                     matTooltip="Display the TMaCS Checking Fixture Build Status Report. This report does not use the selection criteria above.">Checking
                     Fixt Build Status</button>
                  <button mat-menu-item (click)="onFixtureRequestClick()" subFeaturePermission="tmacs"
                     matTooltip="Display the TMaCS Checking Fixture Requirements Report. This report does not use the selection criteria above.">Checking
                     Fixt Reqts Report</button>
                  <button mat-menu-item (click)="onFixtureCompareClick()" subFeaturePermission="tmacs"
                     matTooltip="Display the TMaCS Checking Fixture Required Compare Report. This report does not use the selection criteria above.">Checking
                     Fixt Comp Report</button>
               </mat-menu>
            </span>
            <span class="float-right">
               <button mat-button (click)="onChangeLogClick()">Change Log</button>
            </span>
         </div>

         <hr class="hr-15" />

         <div style="margin: 15px 20px 10px 20px">
            <span class="title-format">Selection Criteria</span>
         </div>

         <mat-grid-list [formGroup]="form" [cols]="4" gutterSize="25px" rowHeight="300px"
            style="padding-top: 5px; margin-left: 20px; margin-right: 20px">
            <mat-grid-tile class="align-items-inherit">
               <mat-form-field style="display: block;">
                  <mat-select placeholder="Program" style="width: 98%" formControlName="programs" multiple
                     [compareWith]="programsEqual">
                     <div class="d-flex">
                        <button mat-button (click)="this.form.get('programs').setValue([])" style="width:100%">Unselect
                           All
                        </button>
                     </div>
                     <mat-option *ngFor="let program of criteria.programs" [value]="program">
                        {{program.programNameYear}}
                     </mat-option>
                  </mat-select>
               </mat-form-field>
               <mat-form-field style="display: block;">
                  <mat-select #areaDropdown placeholder="Area" style="width: 98%" formControlName="areas" multiple>
                     <mat-option *ngFor="let area of criteria.areas" [value]="area">
                        {{area}}
                     </mat-option>
                  </mat-select>
               </mat-form-field>
               <mat-form-field style="display: block;">
                  <input id="keywordInput" matInput placeholder="Type in Keyword" formControlName="keyword" />
               </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile class="align-items-inherit">
               <searchable-autocomplete [options]="criteria.engineers" formControlName="engineer"
                  filterBy="lastFirstName" label="Engineer">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.partNoLHList" [exactMatch]="false"
                  formControlName="partNoLH" filterBy="partNumber" label="Part No LH">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.cspcLHList" [exactMatch]="false" formControlName="cspcLH"
                  filterBy="stablePartCode1" label="CSPC LH">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.gageNoList" [exactMatch]="false" formControlName="gageNo"
                  filterBy="toolNo" label="Gage No">
               </searchable-autocomplete>
            </mat-grid-tile>
            <mat-grid-tile class="align-items-inherit">
               <searchable-autocomplete [options]="criteria.constEngineers" [exactMatch]="false"
                  style="background-color: yellow" formControlName="constEngineer" filterBy="cfe"
                  label="Construction Follow-up Engineer">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.designSourceReps" [exactMatch]="false"
                  formControlName="designSourceRep" filterBy="dsRep" label="Design Source Representative">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.partNoRHList" [exactMatch]="false"
                  formControlName="partNoRH" filterBy="partNumber2" label="Part No RH">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.cspcRHList" [exactMatch]="false" formControlName="cspcRH"
                  filterBy="stablePartCode2" label="CSPC RH">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.fixtureTypes" formControlName="fixtureType"
                  filterBy="typeName" label="Fixture Type">
               </searchable-autocomplete>
            </mat-grid-tile>
            <mat-grid-tile class="align-items-inherit">
               <searchable-autocomplete [options]="criteria.firstUserSources" formControlName="firstUserSource"
                  filterBy="sourceName" label="1st User Source">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.designSources" formControlName="designSource"
                  filterBy="sourceName" label="Design Source">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.userSources" formControlName="userSource"
                  filterBy="sourceName" label="User Source">
               </searchable-autocomplete>
               <searchable-autocomplete [options]="criteria.buildSources" formControlName="buildSource"
                  filterBy="sourceName" label="Build Source">
               </searchable-autocomplete>
            </mat-grid-tile>
         </mat-grid-list>

         <hr class="hr-15" />

         <div class="mx-2 row justify-content-between">
            <span class="col-8">
               <span class="row">
                  <span class="col-xl-2 col-md-3 col-5" featurePermission="tpr">
                     <button mat-raised-button class="m-2 w-100" subFeaturePermission="tpr"
                        (click)="onViewingMenuItemClick('/tprecm/view-update-tpr')"
                        matTooltip="Click this button to go to the View/Update TPR screen.">
                        View/Update TPRs
                     </button>
                  </span>
                  <span class="col-xl-2 col-md-3 col-5" featurePermission="ecm">
                     <button mat-raised-button class="m-2 w-100" subFeaturePermission="tool"
                        (click)="onViewingMenuItemClick('tprecm/ecm')"
                        matTooltip="Click this button to go to the View/Update ECM screen.">
                        View/Update ECMs
                     </button>
                  </span>
               </span>
               <span class="row">
                  <span class="col-xl-2 col-md-3 col-5" featurePermission="tpr">
                     <button mat-raised-button class="m-2 w-100" subFeaturePermission="tpr-resourced"
                        (click)="onViewingMenuItemClick('/tprecm/view-update-tpr/re-source')"
                        matTooltip="Click this button to go to the View Re-sourced TPR screen.">
                        Re-sourced TPRs
                     </button>
                  </span>
                  <span class="col-xl-2 col-md-3 col-5" featurePermission="ecm">
                     <button mat-raised-button class="m-2 w-100" subFeaturePermission="tool"
                        (click)="onViewingMenuItemClick('tprecm/ecm/re-source')"
                        matTooltip="Click this button to go to the View Re-sourced ECM screen.">
                        Re-sourced ECMs
                     </button>
                  </span>
               </span>
            </span>

            <span class="col-1">
               <button style="margin-left: -15px;" class="my-2" (click)="onClearSelectionClick()"
                  mat-raised-button>Clear Selection</button>
            </span>
         </div>
      </div>
      <div *ngSwitchCase="'loading'">
         <div class="spinner-container">
            <mat-spinner class="standard-spinner"></mat-spinner>
         </div>
      </div>
   </div>
</cgp-app-card>
<router-outlet></router-outlet>